import type { Lang } from '@/i18n/locale';
import type { FitnessWorkoutExperienceCopy } from '@/i18n/fitnessExperienceTypes';
import { requireFitnessExperienceCopy } from '@/i18n/translations';
export type { FitnessWorkoutExperienceCopy } from '@/i18n/fitnessExperienceTypes';

/** Synchronous after the shared locale boot/readiness boundary. */
export const getFitnessWorkoutExperienceCopy = (lang: Lang): FitnessWorkoutExperienceCopy => requireFitnessExperienceCopy(lang, 'workout');
